import { render, staticRenderFns } from "./BcDialog.vue?vue&type=template&id=249616fc"
import script from "./BcDialog.vue?vue&type=script&lang=js"
export * from "./BcDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports